<script>
import lazyLoadComponent from '@router/lazyload-component'

export default {
  components: {
    ImageUpload: () => lazyLoadComponent(import('@views/chat/components/FileUpload')),
  
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    category: {
      type: Array,
      required: true,
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
     
    }
  },
  inject: ['routerType'],
  computed: {
   submitData:{
      get(){
        return this.defaultValue
      },
      set(value) {
        this.$emit('update:defaultValue', value)
      },
    },
  },
  watch: {
  
  },
  created() {

  },
  methods: {
    validate() {
     
    },
  },
}
</script>

<template>
<div :class="$style.container">
  <div :class="$style.tabImageStyle">
    <el-form ref="form" :model="submitData" label-position="top">
      <el-row :class="$style.eachRow" :gutter="24">
        <el-col :span="12">
          <h4>圖片設定</h4>
          <el-form-item>
            <ImageUpload v-model="submitData.images" type="service" :class="$style.upload" :show-upload="true" :resource="'product'" :immediate-delete="false"></ImageUpload>
          </el-form-item>
        </el-col>
        <el-col :span="12" :class="$style.rightText">
          <el-form-item>
            <p>圖檔最大 2 MB，檔案格式限 JPG 或 PNG</p>
            <p>圖片比例：16:9，建議尺寸：800*450px</p>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</div>
</template>

<style lang="scss" module>
@import '@design';
@import '@src/design/layout_detail_steps.scss';

.container {
  background-color: white;
}
.tabImageStyle {
  padding: 18px 20px;
}

%img-size {
  width: 100%;
  height: 220px;
  @include max-sm {
    width: calc(100% - 10px);
  }
}
:global {
  :local(.upload) {
    border-top: none !important;
    > div {
      @extend %img-size;
    }
    .image-and-action {
      @extend %img-size;
      & + div {
        @extend %img-size;
      }
    }
  }
}

.eachRow {
  display: flex;
  flex-direction: row;
  align-items: end;
}
.rightText {
  margin-bottom: 50px;
  :global {
    .el-form-item__content > p {
      margin: 0;
      line-height: 20px;
    }
  }
}

</style>
